import { render } from "./Kuboard.vue?vue&type=template&id=b6b34486&scoped=true"
import script from "./Kuboard.vue?vue&type=script&lang=js"
export * from "./Kuboard.vue?vue&type=script&lang=js"

import "./Kuboard.vue?vue&type=style&index=0&id=b6b34486&scoped=true&lang=css"
/* custom blocks */
import block0 from "./Kuboard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b34486"]])

export default __exports__